export default function LoadingTimeline() {
  return (
    <div className="flex h-[72px] flex-col justify-between rounded-lg bg-transparent px-2 sm:px-0 md:h-[52px]">
      <div className="bg-gray-30 dark:bg-gray-70 h-full w-full animate-pulse rounded-2xl md:h-8 md:rounded-lg" />
      <div className="bg-gray-30 dark:bg-gray-70 hidden h-[3px] w-full rounded-full md:block" />
    </div>
  );
}
